module.exports = __webpack_public_path__ + "static/image1-0b3334b0d8322b349656031fefed6597.png";